import { Component, Host, Prop, h } from "@stencil/core";

@Component({
	tag: "location-image",
	styleUrl: "location-image.scss",
	shadow: true,
})
export class LocationImage {
	@Prop() imagePath: string;
	@Prop() imageAlt = "Location Image";
	@Prop() locationName: string;
	@Prop() locationAddress: string;

	render() {
		return (
			<Host
				id="location-image-container"
				style={{ backgroundImage: `url(${this.imagePath})` }}
			>
				<div>
					<h2>{this.locationName}</h2>
					<p>{this.locationAddress}</p>
				</div>
			</Host>
		);
	}
}
